export default __webpack_public_path__ + "static/media/palych.2a4e1483.png";